import type { ProfileRoles } from '@bp/pim-auth-constants';
import type { NavigateFunction } from 'react-router-dom';
import { backendApi } from '../../utils/backendApi';
import { getMatrixRoomId } from '../../utils/matrixRoomId';
import type { BpPermissionChecker } from '../../utils/PermissionChecker';

export interface RedirectToDmMessagePageParams {
  groupUuid: string;
  targetProfileUuid: string;
  targetProfileOrganizationUuid: string;
  targetProfileRole: ProfileRoles;
  organizationUuid: string;
  context: 'course' | 'group';
  permissionChecker: BpPermissionChecker | null;
  navigate: NavigateFunction;
}

export async function redirectToDmMessagePage({
  groupUuid,
  targetProfileUuid,
  targetProfileOrganizationUuid,
  targetProfileRole,
  organizationUuid,
  context,
  permissionChecker,
  navigate,
}: RedirectToDmMessagePageParams): Promise<boolean> {
  const hasPermission =
    context === 'course'
      ? permissionChecker?.canDirectMessageWithinCourse(
          {
            uuid: groupUuid,
            organization: { uuid: organizationUuid },
          },
          {
            uuid: targetProfileUuid,
            organization: { uuid: targetProfileOrganizationUuid },
            role: targetProfileRole,
          },
        )
      : permissionChecker?.canDirectMessageWithinGroup(
          {
            uuid: groupUuid,
            organization: { uuid: organizationUuid },
          },
          {
            uuid: targetProfileUuid,
            organization: { uuid: targetProfileOrganizationUuid },
            role: targetProfileRole,
          },
        );

  if (!targetProfileUuid || !hasPermission) {
    return false;
  }

  const response = await backendApi.createMatrixDm(targetProfileUuid);
  const json = await response.json();

  if (json.success && json.matrixRoomId) {
    const matrixRoomId = await getMatrixRoomId(json.matrixRoomId);
    navigate(`/messages/${matrixRoomId}`);
    return true;
  }

  return false;
}
